import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchStoragePendingCars = () => apiActionCreator({
  'endpoint': '/pendingStorageProcesses/cars',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_STORAGE_PENDING,
    ActionTypes.FETCHED_STORAGE_PENDING,
    [
      ActionTypes.FETCHED_STORAGE_PENDING_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const emptyStoragePendingCarsValues = () => ({
  'type': ActionTypes.EMPTY_STORAGE_PENDING_CARS,
});
